import {message, Modal, notification} from 'antd'
import {deleteOriginalFile} from "../../../../../services/api/originalFilesManagementServices"

const reqDeleteFile = async (fileId) => {
    const response = await deleteOriginalFile(fileId)

    const {success} = response

    if (!success) throw new Error(response.message)

    return true
}

export default function (fileId, barcode, afterDelete) {
    Modal.confirm({
        title: `Xác nhận xóa file gốc` + (barcode ? ` của đơn hàng ${barcode}` : '') + '?',
        cancelText: 'Hủy',
        onOk() {
            reqDeleteFile(fileId).then(() => {
                message.success('Xóa thành công')

                if (typeof afterDelete === 'function') {
                    afterDelete()
                }
            }).catch(err => {
                notification.error({
                    message: 'ERROR',
                    description: err.message,
                    duration: 0,
                })
            })
        },
    })
}
